import React, {useState, useEffect} from 'react';
import Produtos from "./Produtos";
import Rebanho from "./Rebanho";
import Aplicacoes from "./Aplicacoes";
import {FazendaObject} from "../../../models/Fazenda";
import CalendarioHome from "./CalendarioHome";
import {post} from "../../../utils/frRequest";
import {useAppDispatch} from "../../../lib/hooks";
import {actions} from "../../../lib/app";
import {SwitchTransition, CSSTransition} from "react-transition-group";


interface CalendarioProps {
  fazenda: FazendaObject;
  instance?: any;
  onConcluir: () => void;
  produtos: any[];
  rebanho: any[];
  calendario: any[];
}

const Calendario: React.FC<CalendarioProps> = (props) => {
  const [secaoAtiva, setSecaoAtiva] = useState('home');
  const [produtos, setProdutos] = useState<any[]>(props.produtos);
  const [rebanho, setRebanho] = useState<any[]>(props.rebanho);
  const [calendario, setCalendario] = useState<any[]>(props.calendario);
  const [produtosOk, setProdutosOk] = useState(props.produtos.length > 0);
  const [rebanhoOk, setRebanhoOk] = useState(props.rebanho.length > 0);
  const [calendarioOk, setCalendarioOk] = useState(props.calendario.length > 0);
  const [gravar, setGravar] = useState(false);
  const [gravando, setGravando] = useState(false);
  const dispatch = useAppDispatch();

  const fazendaId = props.fazenda.id;
  const onConcluir = props.onConcluir;

  // gravar calendário sanitário pronto
  useEffect(() => {
    if (gravar && !gravando) {
      setGravando(true);
      post('/veApi/vet_experts/gravar',
        {fazendaId, produtos, rebanho, calendario})
        .then(({success, error}) => {
          if (!success) {
            console.error(`Erro inesperado em gravar: ${error}`);
            dispatch(actions.notifyError('Erro ao gravar calendário.'));
            return;
          }

          setGravar(false);
          // setGravando(false);
          onConcluir();
        });
    }
  }, [fazendaId, gravar, gravando, produtos, rebanho, calendario, dispatch, onConcluir])

  return (
    <SwitchTransition>
      <CSSTransition
        key={secaoAtiva}
        classNames="transition-slide-l"
        timeout={250}
      >
        <div className="w-full h-full flex flex-col">
          {
            secaoAtiva === 'home' &&
            <CalendarioHome
              fazenda={props.fazenda}
              produtosOk={produtosOk}
              rebanhoOk={rebanhoOk}
              calendarioOk={calendarioOk}
              setSecaoAtiva={setSecaoAtiva}
              onConcluir={() => {
                setGravando(false);
                setGravar(true);
              }}
              gravando={gravando}
            />
          }
          {
            secaoAtiva === 'produtos' &&
            <Produtos
              produtos={produtos}
              setProdutos={produtos => {
                setProdutos(produtos);
                setProdutosOk(true);
              }}
              setSecaoAtiva={setSecaoAtiva}
            />
          }
          {
            secaoAtiva === 'rebanho' &&
            <Rebanho
              fazenda={props.fazenda}
              rebanho={rebanho}
              setRebanho={rebanho => {
                setRebanho(rebanho);
                setRebanhoOk(true);
              }}
              setSecaoAtiva={setSecaoAtiva}
            />
          }
          {
            secaoAtiva === 'calendario' &&
            <Aplicacoes
              setSecaoAtiva={setSecaoAtiva}
              fazenda={props.fazenda}
              calendario={calendario}
              rebanho={rebanho}
              produtos={produtos}
              setCalendario={calendario => {
                setCalendario(calendario);
                setCalendarioOk(true);
              }}
            />
          }
        </div>
      </CSSTransition>
    </SwitchTransition>
  )
}

export default Calendario;
